import type { UseFormReturn } from 'react-hook-form';

import type { MarginWrite } from '../credit-note.margin';
import type { CreditNoteTabsValues } from './tab-form';

/* eslint-disable lingui/no-unlocalized-strings -- caminhos e valores técnicos do formulário (U02), não texto de UI */
type AmortizationPath = 'amortization.requestedAmount' | 'amortization.valueMarginReserve' | 'amortization.calculateByValueType' | 'amortization.firstPaymentDate';

/**
 * Escreve a margem escolhida no formulário da operação, como o `setValue` do legado (SelectWarrantyContainer.tsx:124-130,
 * 174-184; helpers:149-151 e :228/:267): a garantia, o valor solicitado, a reserva de margem e o cálculo pela parcela
 * (e a 1ª parcela do repasse Dataprev). Nada vai ao servidor: o Salvar ou o "Incluir garantias" enviam.
 */
export function applyMarginWrite(form: UseFormReturn<CreditNoteTabsValues>, write: MarginWrite) {
  const set = form.setValue as unknown as (path: AmortizationPath, value: unknown, options: { shouldDirty: boolean }) => void;
  form.setValue('warranty', write.warranty, { shouldDirty: true });
  set('amortization.requestedAmount', write.requestedAmount, { shouldDirty: true });
  set('amortization.valueMarginReserve', write.requestedAmount, { shouldDirty: true });
  set('amortization.calculateByValueType', 'Payment', { shouldDirty: true });
  if (write.firstPaymentDate) set('amortization.firstPaymentDate', write.firstPaymentDate, { shouldDirty: true });
}
/* eslint-enable lingui/no-unlocalized-strings */

/** O `watch('productId')` do formulário (UpdateManualWarrrantyContainer.tsx:16; MarginQueryFormContainer.tsx:156): o valor como está, sem trocar `null` por `''`. */
export function formProductId(form: UseFormReturn<CreditNoteTabsValues>): string | null | undefined {
  const value = (form.getValues() as unknown as Record<string, unknown>)['productId'];
  return typeof value === 'string' || value === null ? value : undefined;
}
